import React from 'react';

import {Helmet, useNavigate, useParams} from 'views/module';

import EventDetail from 'views/scenes/schedule/event_details/EventDetail';
import SCHEDULE_SOURCES from 'views/scenes/schedule/schedule_source';

import FLAGS, {useFlag} from 'utils/feature_flags/flags';

const LoomEventDetailPage = () => {
  const {eventRn} = useParams();
  const scheduleReadFlag = useFlag(FLAGS.SCHEDULE_READS_FROM_LOOM);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (scheduleReadFlag.isLoading || scheduleReadFlag.isEnabled) return;

    navigate(`/schedule/event/${eventRn}`, {replace: true});
  }, [scheduleReadFlag.isEnabled, scheduleReadFlag.isLoading, navigate, eventRn]);

  if (scheduleReadFlag.isLoading || !scheduleReadFlag.isEnabled) return null;

  return (
    <>
      <Helmet>
        <title>Quilt: Event Details (Loom)</title>
      </Helmet>
      <EventDetail
        eventRn={eventRn}
        scheduleSource={SCHEDULE_SOURCES.LOOM}
      />
    </>
  );
};

export default LoomEventDetailPage;
